import { render } from "./AddBooking.vue?vue&type=template&id=77bf8ba4"
import script from "./AddBooking.vue?vue&type=script&lang=js"
export * from "./AddBooking.vue?vue&type=script&lang=js"
script.render = render

export default script